import React from 'react';
import { withRouter } from 'react-router-dom';

import GameExplorer from './GameExplorer';
import { useBreadcrumbs, usePath } from '../../hooks';
import { useTeam, useTeamGames, useSeason } from '../shared/hooks';
import { useGameNavigation } from './useGameNavigation';
import { useGameExplorerStats } from './useGameExplorerStats';
import { useGameSelector } from './useGameSelector';
import { useBoxscore } from './useBoxscore';
import { useShotCharts } from './useShotCharts';
import { seasonName, teamName } from '../../lib/format';

function createBreadcrumbs(team, season, pathTo) {
  if (!team) return;

  return [
    { title: 'Teams', url: pathTo('teams') },
    { title: `[${seasonName(season)}] ${teamName(team)}`, url: pathTo('team') },
    { title: 'Games', url: pathTo('games') },
    { title: 'Game Explorer' },
  ];
}

const GameExplorerPage = ({
  leagueId,
  seasonId,
  teamId,
  gameId,
  team,
  history,
}) => {
  team = useTeam(teamId);
  const games = useTeamGames(leagueId, seasonId, team);
  const season = useSeason(seasonId);
  const boxscore = useBoxscore(gameId);
  const shotCharts = useShotCharts(gameId);
  const stats = useGameExplorerStats(gameId);
  const shiftLocked =
    stats &&
    (stats.home_shifts.length === 0 ||
      !stats.query[0].data.locked ||
      stats.query[0].data.ignored);
  const pathTo = usePath(leagueId, seasonId, teamId);
  useBreadcrumbs(createBreadcrumbs, [team, season, pathTo]);

  const gameSelector = useGameSelector(gameId, games, history, pathTo);
  const gameNavigation = useGameNavigation(gameId, games);

  const handleChangeGame = gameId => {
    history.push(pathTo('game-explorer', gameId));
  };

  return (
    <GameExplorer
      team={team}
      gameSelector={gameSelector}
      gameNavigation={gameNavigation}
      stats={stats}
      pathTo={pathTo}
      onGameChange={handleChangeGame}
      season={season}
      boxscore={boxscore}
      shotCharts={shotCharts}
      shiftLocked={shiftLocked}
    />
  );
};

export default withRouter(GameExplorerPage);
